import React, { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { MDBDataTableV5 } from "mdbreact";
import MyBragSheetTable from "./MyBragSheetTable";
import MyBragSheetForm from "./MyBragSheetForm";
import MyBragSheetDataList from "./MyBragSheetDataList";
import MyBragSheetInput from "./MyBragSheetInput";
import MyBragSheetTableInput from "./MyBragSheetTableInput";

import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import MyBragSheetTopCoursesTable from "./MyBragSheetTopCoursesTable";
import { currentDateFunction } from "./MyBragSheet";


const createOneMoreRowFromData = (data) => {
    const tmp = {}

    data.forEach(element => {
        tmp[`${element.field}_edit_flag`] = true
        switch (element.whatType) {
            case "static":
                tmp[element.field] = element.staticVal
                tmp[`${element.field}_edit_flag`] = false
                break;
            case "text":
                tmp[element.field] = ""
                break;
            case "checkbox":
                tmp[element.field] = false
                break;
            case "date":
                tmp[element.field] = currentDateFunction()
                break;

            default:
                tmp[element.field] = ""
                break;
        }
        if (element.hasOwnProperty("defaultVal")) {
            tmp[element.field] = element.defaultVal
        }
    })
    tmp.is_editable = true;
    return tmp;
}
const createRowsFromData = (data, rows, setRows) => {
    const tmp_rows = []
    rows.forEach((row, index) => {
        const tmp = {}
        data.filter(element => !element.field.includes("_edit_flag")).forEach(element => {
            // //console.log("setData")
            // //console.log(setData)
            // console.log("element")
            // console.log(element)
            if ((!(row.is_editable - 0)) && row.hasOwnProperty(element.field)) {
                tmp[element.field] = row[element.field]
            } else {
                // console.log("row[`${element.field}_edit_flag`]")
                // console.log(row[`${element.field}_edit_flag`])
                if (false == (row[`${element.field}_edit_flag`] - 0)) {
                    tmp[element.field] = row[element.field]
                } else {
                    if (!row.hasOwnProperty(element.field)) {
                        row[element.field] = ""
                    }
                    switch (element.whatType) {
                        case "static":
                            tmp[element.field] = element.staticVal
                            break;
                        case "textNoEdit":
                            tmp[element.field] = row[element.field]
                            break;
                        case "text":
                            tmp[element.field] = (<input
                                onChange={(e) => {
                                    row[element.field] = e.target.value
                                    setRows(x => [...x])
                                }}
                                type="text"
                                name={element.field}
                                placeholder="type here"
                                // defaultValue={row[element.field] ? row[element.field] : element.defaultVal}
                                value={row[element.field]}
                            />)
                            break;
                        case "date":
                            tmp[element.field] = (<input
                                type="date"
                                name={element.field}
                                value={row[element.field]}
                                onChange={(e) => {
                                    row[element.field] = e.target.value
                                    setRows(x => [...x])
                                }}
                            />)
                            break;
                        case "checkbox":
                            tmp[element.field] = (<input
                                type="checkbox"
                                name={element.field}
                                checked={row[element.field]}

                                onChange={(e) => {
                                    row[element.field] = e.target.checked
                                    setRows(x => [...x])
                                }}
                            />)
                            break;

                        default:
                            tmp[element.field] = ""
                            break;
                    }
                }
            }
        });
        tmp["action"] = (<IconButton
            color="primary"
            onClick={() => {
                //console.log("DeleteIcon")
                //console.log("index")
                //console.log(index)
                setRows(x => x.filter((_, i) => i !== index))
            }}
        >
            <DeleteIcon fontSize="large" />
        </IconButton>);
        // //console.log("tmp")
        // //console.log(tmp)
        tmp_rows.push(tmp)

    });
    return tmp_rows
}

const MyBragSheetTableAbstract = (props) => {
    return (
        <MyBragSheetTable
            id={props.id}
            data={{ columns: props.dataCols, rows: createRowsFromData(props.dataCols, props.dataRows, props.setDataRows) }}
            rows={props.dataRows}
            addFunc={() => {
                props.setDataRows(x => [...x, { ...createOneMoreRowFromData(props.dataCols), id: "new" }])
            }}
            saveFlag={props.saveFlag}
            saveFunction={props.saveFunction}
            editable={props.editable}
        >
            {props.children}
        </MyBragSheetTable>
    )
}

export default MyBragSheetTableAbstract